import React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { grey } from "@mui/material/colors";
import "./style.css";

const NensikiCustomSlider = ({
  nensikiSliderValue, // この値は配列として [最小年, 最大年] を持つ
  setNensikiSliderValue,
  iniNensikiSliderValue,
}) => {
  // スライダーの値が変更されたときのハンドラ
  const handleChange = (event, newValue) => {
    // 新しい値（年のみ）をセットする
    setNensikiSliderValue(newValue);
  };

  const createNensikiMarks = (startYear, endYear) => {
    const marks = [];
    // 10の位が0になる最初の年を計算する
    const firstDecadeYear = startYear - (startYear % 10);
    for (let year = firstDecadeYear; year <= endYear; year += 10) {
      // 10の位が0の年にマークを追加する
      if (year >= startYear) {
        marks.push({
          value: year,
          label: `${year}年`,
        });
      }
    }
    return marks;
  };

  // スライダーの値をラベルにフォーマットする関数（年のみ）
  const formatNensikiForLabel = (nensikiValue) => {
    // 年だけを返す
    return `${nensikiValue}年`;
  };

  // 開始年と終了年
  const startYear = iniNensikiSliderValue[0];
  const endYear = iniNensikiSliderValue[1];

  const nensikiMarks = createNensikiMarks(startYear, endYear);

  return (
    <Box className='box' sx={{ width: 270 }}>
      <div className='iconTitle'>
        <CalendarMonthIcon sx={{ color: grey[700] }} />
        <h3 className='sliderTitle'>年式フィルタ</h3>
      </div>

      <Slider
        className='slider'
        color='warning'
        value={nensikiSliderValue}
        onChange={handleChange}
        valueLabelDisplay='auto'
        min={startYear}
        max={endYear}
        marks={nensikiMarks}
        step={1} // ステップを1年に設定
        getAriaValueText={formatNensikiForLabel}
        style={{ width: 200, margin: 30 }}
      />
    </Box>
  );
};

export default NensikiCustomSlider;
